// Fil: src/Login.js
import React, { useState } from 'react';

function Login({ onLoginSuccess }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  console.log("start of login component")
  const handleSubmit = async (event) => {
    event.preventDefault();
    setError(''); // Nulstil fejl
    console.log("login submit")
    const apiURL = `${process.env.REACT_APP_API_URL}/api/login`;

    //const apiURL = `https://test.cdb-admin.dk/api/login`;

    console.log(`[${apiURL}]`)
    try {

      const response = await fetch(apiURL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
        credentials: 'include'
      }); 

      const data = await response.json();
      console.log("data is:")
      console.log(data)

      if (!response.ok) {
        // Hvis serveren svarer med 401, 500 etc.
        console.log("response not ok")
        console.log("response " + response.status)
        console.log(response)
        throw new Error(data.message || 'Login fejlede.');
      }

      // Kald funktionen fra App.js for at signalere succesfuldt login
      onLoginSuccess(data);

    } catch (err) {
      console.log("error in call to login [[" + err.message+"]]")
      setError(err.message);
    }
  };

  return (
    <div className="app-container" style={{ maxWidth: '400px' }}>
      <h1>Login</h1>
      <form onSubmit={handleSubmit} className="add-person-form">
        <div className="form-field">
          <label htmlFor="username">Brugernavn:</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div className="form-field">
          <label htmlFor="password">Kodeord:</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {error && <p className="error-message" style={{ marginBottom: '15px' }}>{error}</p>}
        <button type="submit">Log Ind</button>
      </form>
    </div>
  );
}

export default Login;